import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "snippet"]
  static values = { url: String }

  draft(event) {
    event.preventDefault()

    const topic = this.inputTarget.value
    if (!topic) {
      alert("Please enter a topic first.")
      return
    }

    this.toggleLoading(true)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ topic: topic })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.insertContent(data)
        } else {
          alert("Error: " + data.error)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        alert("Something went wrong.")
      })
      .finally(() => {
        this.toggleLoading(false)
      })
  }

  insertContent(data) {
    let trixEditor = document.querySelector("trix-editor")
    if (!trixEditor && this.element.querySelector("trix-editor")) {
        trixEditor = this.element.querySelector("trix-editor")
    }

    if (trixEditor && data.content) {
      trixEditor.editor.insertHTML(data.content)
    }

    if (this.hasSnippetTarget && data.social_media_snippet) {
      this.snippetTarget.value = data.social_media_snippet
    }
  }

  toggleLoading(isLoading) {
    if (isLoading) {
      this.buttonTarget.disabled = true
      this.originalButtonText = this.buttonTarget.innerHTML
      this.buttonTarget.innerHTML = `
        <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Drafting...
      `
    } else {
      this.buttonTarget.disabled = false
      if (this.originalButtonText) {
         this.buttonTarget.innerHTML = this.originalButtonText
      } else {
         this.buttonTarget.textContent = "Draft with AI"
      }
    }
  }
}
